import { site } from "@/data/site";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-10" data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 px-6 sm:flex-row sm:items-center lg:px-12">
        <p className="font-display text-sm font-black uppercase tracking-tight text-white">
          CHRIS<span className="text-purple">JST</span>
          <span className="text-gold">PERFORMANCE</span>
        </p>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/35">
          Strength & Conditioning for Racing Drivers
        </p>
        <div className="flex items-center gap-6">
          <a
            href={site.igUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs font-black uppercase tracking-[0.2em] text-gold transition-colors duration-200 hover:text-purple"
            data-testid="footer-instagram-link"
          >
            IG {site.igHandle}
          </a>
          <a
            href={site.tiktokUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs font-black uppercase tracking-[0.2em] text-gold transition-colors duration-200 hover:text-purple"
            data-testid="footer-tiktok-link"
          >
            TikTok {site.tiktokHandle}
          </a>
        </div>
      </div>
    </footer>
  );
}
